import React, {useContext} from "react";
import { GERMAN } from "../actions/language";
import {LanguageContext} from "../context/LanguageContext";
import {PlatformContext} from "../context/PlatformContext";
import {DESKTOP} from "../actions/mobile";
import PrefixName from "redux-form/lib/util/prefixName";
import {
    BUSINESS_NAME_WITH_POSTFIX, BUSINESS_PAGE_URI,
    OFFICE_CONTACT_EMAIL,
    OFFICE_CONTACT_OFFICE_PHONE_NUMBER,
    OFFICE_LOCATION_STREET
} from "../env";

const DataProtection = () => {
    const { language } = useContext(LanguageContext);
    const { platform } = useContext(PlatformContext);

    return (
        <div className="container fancy-paragraph mb-5 p-standard">
            <h1 className="text-center p-standard-top fancy-title my-5">
                <b style={platform === DESKTOP ? {fontSize: "40px"} : {fontSize: "20px"}}>
                    {language === GERMAN ? 'Datenschutzerklärung' : 'Política de privacidade'}
                </b>
            </h1>
            <div className={platform === DESKTOP ? "fancy-paragraph justify" : "fancy-paragraph"}>
                <section className="p-standard-bottom">
                    <p>
                        {language === GERMAN
                            ? 'Der Schutz Ihrer personenbezogenen Daten ist uns bei Tomé & Martins Dienstleistungen ein wichtiges Anliegen. Wir verarbeiten Ihre personenbezogenen Daten im Einklang mit den geltenden datenschutzrechtlichen Bestimmungen, insbesondere der Datenschutz-Grundverordnung (DSGVO). Nachfolgend informieren wir Sie, wie wir Ihre Daten erheben, verarbeiten und schützen, wenn Sie unsere Dienstleistungen in Anspruch nehmen.'
                            : 'A proteção dos seus dados pessoais é uma preocupação importante para nós na Tomé & Martins Dienstleistungen. Processamos os seus dados pessoais de acordo com os regulamentos de proteção de dados aplicáveis, em particular o Regulamento Geral de Proteção de Dados (RGPD). De seguida, informamos como recolhemos, processamos e protegemos os seus dados quando utiliza os nossos serviços.'}
                    </p>
                </section>
                <section className="p-standard-bottom">
                    <h5>
                        <b>{language === GERMAN ? '1. Verantwortlicher für die Datenverarbeitung' : '1. Pessoa responsável pelo tratamento dos dados'}</b>
                    </h5>
                    <p>
                        {language === GERMAN
                            ? 'Verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten ist:'
                            : 'Somos responsáveis pelo tratamento dos seus dados pessoais:'}
                    </p>
                    <address>
                        {BUSINESS_NAME_WITH_POSTFIX}<br/>
                        {OFFICE_LOCATION_STREET}<br/>
                        {OFFICE_CONTACT_OFFICE_PHONE_NUMBER}<br/>
                        {OFFICE_CONTACT_EMAIL}<br/>
                        {BUSINESS_PAGE_URI}
                    </address>
                </section>
                <section className="p-standard-bottom">
                    <h5>
                        <b>{language === GERMAN ? '2. Erhebung und Verarbeitung personenbezogener Daten' : '2. Recolha e tratamento de dados pessoais'}</b>
                    </h5>
                    <p>
                        {language === GERMAN
                            ? 'Im Rahmen unserer Dienstleistungen erheben und verarbeiten wir personenbezogene Daten, die notwendig sind, um unsere Dienstleistungen zu erbringen. Zu den verarbeiteten Daten gehören insbesondere:'
                            : 'No âmbito dos nossos serviços, recolhemos e tratamos os dados pessoais necessários para prestar os nossos serviços. Os dados tratados incluem, nomeadamente:'}
                    </p>
                    <ul>
                        <li>
                            {language === GERMAN
                                ? 'Stammdaten wie Name, Adresse, Geburtsdatum, Telefonnummer, E-Mail-Adresse'
                                : 'Dados de base, tais como nome, endereço, data de nascimento, número de telefone, endereço eletrónico'}
                        </li>
                        <li>
                            {language === GERMAN
                                ? 'Finanzdaten wie Einkommens- und Lohninformationen, Steuer- und Sozialversicherungsnummer'
                                : 'Dados financeiros, como informações sobre rendimentos e salários, número de contribuinte e de segurança social'}
                        </li>
                        <li>
                            {language === GERMAN
                                ? 'Dokumente wie Steuerbescheide, Lohnabrechnungen und ähnliche relevante Unterlagen'
                                : 'Documentos tais como declarações fiscais, recibos de vencimento e outros documentos relevantes semelhantes'}
                        </li>
                    </ul>
                    <p>
                        {language === GERMAN
                            ? 'Die Daten werden ausschließlich für die Erfüllung unserer vertraglichen Verpflichtungen Ihnen gegenüber sowie zur Erfüllung rechtlicher Verpflichtungen verarbeitet.'
                            : 'Os dados são tratados exclusivamente para o cumprimento das nossas obrigações contratuais e legais para consigo.'}
                    </p>
                </section>
                <section className="p-standard-bottom">
                    <h5>
                        <b>{language === GERMAN ? '3. Zweck der Datenverarbeitung' : '3. Objetivo do tratamento de dados'}</b>
                    </h5>
                    <p>
                        {language === GERMAN
                            ? 'Die Verarbeitung Ihrer personenbezogenen Daten erfolgt zu folgenden Zwecken:'
                            : 'Os seus dados pessoais são tratados para as seguintes finalidades:'}
                    </p>
                    <ul>
                        <li>
                            {language === GERMAN
                                ? 'Erbringung unserer Dienstleistungen'
                                : 'Prestação dos nossos serviços'}
                        </li>
                        <li>
                            {language === GERMAN
                                ? 'Kommunikation mit Behörden und anderen relevanten Stellen'
                                : 'Comunicação com autoridades e outras entidades relevantes'}
                        </li>
                        <li>
                            {language === GERMAN
                                ? 'Erfüllung der gesetzlichen Aufbewahrungspflichten'
                                : 'Cumprimento das obrigações legais de retenção'}
                        </li>
                    </ul>
                </section>
                <section className="p-standard-bottom">
                    <h5>
                        <b>{language === GERMAN ? '4. Rechtsgrundlage der Verarbeitung' : '4. Base jurídica do tratamento'}</b>
                    </h5>
                    <ul>
                        <li>
                            {language === GERMAN
                                ? 'Art. 6 Abs. 1 lit. b DSGVO – Verarbeitung zur Erfüllung eines Vertrags'
                                : 'Art. 6, n.º 1, alínea b) do RGPD - Processamento para o cumprimento de um contrato'}
                        </li>
                        <li>
                            {language === GERMAN
                                ? 'Art. 6 Abs. 1 lit. c DSGVO – Verarbeitung zur Erfüllung einer rechtlichen Verpflichtung'
                                : 'Art. 6, n.º 1, alínea c) do RGPD - Processamento para cumprir uma obrigação legal'}
                        </li>
                        <li>
                            {language === GERMAN
                                ? 'Art. 6 Abs. 1 lit. f DSGVO – Verarbeitung zur Wahrung berechtigter Interessen'
                                : 'Art. 6, n.º 1, alínea f) do RGPD - Tratamento para proteção de interesses legítimos'}
                        </li>
                    </ul>
                </section>
                <section className="p-standard-bottom">
                    <h5>
                        <b>{language === GERMAN ? '5. Weitergabe von Daten' : '5. Divulgação de dados'}</b>
                    </h5>
                    <p>
                        {language === GERMAN
                            ? 'Ihre personenbezogenen Daten werden ausschließlich im Rahmen der erforderlichen Dienstleistungen weitergegeben, z.B. an Behörden, sofern dies gesetzlich erforderlich ist.'
                            : 'Os seus dados pessoais só serão transmitidos no âmbito dos serviços necessários, por exemplo, a autoridades, se tal for exigido por lei.'}
                    </p>
                </section>
                <section className="p-standard-bottom">
                    <h5>
                        <b>{language === GERMAN ? '6. Speicherdauer' : '6. Período de armazenamento'}</b>
                    </h5>
                    <p>
                        {language === GERMAN
                            ? 'Wir speichern Ihre personenbezogenen Daten nur so lange, wie es erforderlich ist.'
                            : 'Apenas guardamos os seus dados pessoais durante o tempo necessário.'}
                    </p>
                </section>
            </div>
        </div>
    );
}

export default DataProtection


// WEBPACK FOOTER //
// ./src/components/DataProtection.js